import { AxiosResponse } from 'axios'

// realisations
import { http } from '../realisations/Http.realisation'

// types
import {
    DiscountTypePayload,
    GetDiscountTypesParams,
    GetDiscountTypesResponse,
    AddUserDiscountPayload,
    GetDiscountTypeResponse,
} from '@/core/types/delivery-discounts.types'

export class DeliveryDiscountsRepository {
    getDiscountTypes(
        params: GetDiscountTypesParams
    ): Promise<AxiosResponse<GetDiscountTypesResponse>> {
        return http.get('/order/api/v1/call-center/discount-types', { params })
    }

    getDiscountType(discount_type_id: number): Promise<AxiosResponse<GetDiscountTypeResponse>> {
        return http.get(`/order/api/v1/call-center/discount-types/${discount_type_id}`)
    }

    createDiscountType(payload: DiscountTypePayload): Promise<AxiosResponse<void>> {
        return http.post('/order/api/v1/call-center/discount-types', payload)
    }

    updateDiscountType(
        discount_type_id: number,
        payload: DiscountTypePayload
    ): Promise<AxiosResponse<void>> {
        return http.put(`/order/api/v1/call-center/discount-types/${discount_type_id}`, payload)
    }

    addUserDiscount(payload: AddUserDiscountPayload): Promise<AxiosResponse<void>> {
        return http.post('/order/api/v1/call-center/user-discounts', payload)
    }
}
